import styled, { css } from 'styled-components';

export const PopupTitleContainer = styled.div`
  padding: 16px 0;
  box-shadow: 0px -1px 0px 0px #e3e6ea inset;
`;

export const PopupWrapper = styled.div`
  width: fit-content;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
`;

export const PopupTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 24px;
`;

export const PopupTitle = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const PopupTitleSpan = styled.span`
  margin: 0;
  &:before {
    content: '\\e91f';
    font-family: 'Icomoon';
    cursor: pointer;
  }
`;

export const Container = styled.div``;

export const extendLoaderStyle = css`
  height: 16px;
  width: 17px;
  border: 1px solid #f3f3f3;
  border-top: 3px solid #3498db;
  margin: 0;
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  box-shadow: 0px -1px 0px 0px #e3e6ea inset;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: end;
  border-top: 1px solid #d9dbdf;
  gap: 8px;
  padding: 16px;
`;

export const extendGrayButtonStyle = css`
  width: 96px;
  border-radius: 8px;
  border: 1px solid #d9dbdf;
  background: #f1f4f6;
  color: #484848;
  padding: 7px 10px;
`;

export const extendBlueButtonStyle = css`
  width: 101px;
  border-radius: 8px;
  border: 1px solid #e3e6ea;
  background: #0070cd;
  color: #fff;
  padding: 7px 10px;
`;

export const InputField = styled.input`
  width: 100%;
  height: 42px;
  margin-top: 4px;
  padding: 8px 12px;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black};
  box-sizing: border-box;

  border-radius: 8px;
  border: ${props => (props.isDuplicateError ? '2px solid #DB3226' : '1px solid #c9cbce')};

  ::-webkit-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  ::-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-ms-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }

  &:focus {
    border: 2px solid ${({ theme }) => theme.colors.blueMain};
    outline: none;
  }
`;

export const InputBasicField = styled.input`
  border: none;
  width: 100%;
  background-color: ${({ disabled, theme }) => (disabled ? theme.colors.grey100 : 'white')};
  &:focus {
    outline: none;
  }
`;

export const InputFieldWrapper = styled.div`
  display: flex;
  height: 24px;
  width: 100%;
  padding: 8px 2px 8px 12px;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  border: ${props => (props.isDuplicateError ? '2px solid #DB3226' : '1px solid #c9cbce')};
  background-color: ${({ disabled, theme }) => (disabled ? theme.colors.grey100 : 'white')};
`;

export const InputFieldIcon = styled.div`
  display: flex;
  width: 36px;
  height: 36px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.grey100};
`;

export const FieldLabel = styled.p`
  color: #484848;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
  width: 150px;
`;

export const FieldContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const WarningMsg = styled.p`
  margin: 0;
  color: #db3226;
  font-size: 13px;
`;
